import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=0715d658&scoped=true"
import script from "./LoginHistory.vue?vue&type=script&lang=js"
export * from "./LoginHistory.vue?vue&type=script&lang=js"
import style0 from "./LoginHistory.vue?vue&type=style&index=0&id=0715d658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715d658",
  null
  
)

export default component.exports